//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import SearchModeConfigDrawer from './components/searchModeConfigDrawer.vue';
import {get, round} from 'lodash';
import {cosDownload} from '@/utils/cosDownload';
import RetrievalCard from './components/retrievalCard.vue';
import { SEARCH_MODE } from '@/utils/constant';
const searchModeConfigKeys = ['top_k', 'score_threshold', 'reranking_mode', 'reranking_model', 'reranking_enable', 'weights', 'search_mode'];
function parseJson(str, defaultValue) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return defaultValue;
  }
}
export default {
  data() {
    return {
      query: '',
      loading: false,
      retrievalLoading: false,
      visiable: false,
      dataset: {},
      visible: false,
      retrievalResult: null,
      detailVisible: false,
      detailItem: {},
    };
  },
  components:{
    SearchModeConfigDrawer,
    RetrievalCard,
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    searchMode() {
      return SEARCH_MODE[this.dataset?.search_mode];
    }
  },
  async created() {
    await this.getDataset();
  },
  methods: {
    get,
    round,
    async getDataset() {
      try {
        this.dataset = {};
        const { dataset } = await this.$request({
          url: this.$api.getAgentDataset,
          data: {
            id: this.$route?.query?.dataset_id,
          },
        });
        this.dataset = dataset;
      } catch (err) {
        console.log(err);
        this.dataset = {};
      }
    },
    handleSearchModeConfig() {
      this.visible = true;
    },
    resetSearchMode(searchMode) {
      for(const k of Object.keys(searchMode)) {
        this.$set(this.dataset, k, searchMode[k]);
      }
    },
    async handleRetrieval() {
      if(!this.query.trim()) {
        this.$message.warning('请输入查询文本');
        return;
      }
      this.retrievalResult = [];
      this.retrievalLoading = true;
      const searchModoConfig = {};
      searchModeConfigKeys.forEach(key => {
        if(['weights', 'reranking_model'].includes(key)) {
          searchModoConfig[key] = parseJson(this.dataset[key]);
        } else {
          searchModoConfig[key] = this.dataset[key];
        }
      });
      try {
        const { documents } = await this.$request({
          showLoading: false,
          url: this.$api.retrievalKnowledge,
          data: {
            query: this.query,
            datasets: [this.$route?.query?.dataset_id],
            ...searchModoConfig,
          },
        });
        this.retrievalResult = documents || [];
        this.retrievalLoading = false;
      } catch(e) {
        console.error(e);
        this.retrievalLoading = false;
      }
    },
    async download(e, url) {
      e.stopPropagation();
      try {
        await cosDownload(url, { isPrivate: true });
      } catch(e) {
        console.log(e);
      }
    },
    openDetailDlg(item) {
      this.detailItem = item;
      this.detailVisible = true;
    },
  },
};
